function Diretoria() {
    return 'Diretoria 2'
}

export default Diretoria